import { switchingRoleOf } from "../switchingRoleOf";
import type { RouteDestinations } from "./types";

// Addressed by element, never by index; the role is what lets the router wire a lighting circuit switch-first.
export const routeDestinations: RouteDestinations = ({ paths, deviceTypeByElementId }) =>
  paths.flatMap((path) => {
    const position = path.waypoints[path.waypoints.length - 1];
    if (!path.elementId || !position) return [];
    const role = path.isFeeder
      ? null
      : switchingRoleOf({
      deviceType: deviceTypeByElementId?.[path.elementId],
      name: path.destinationName,
    });
    return [{ elementId: path.elementId, position, ...(role ? { role } : {}) }];
  });
